<template>
    <page-container>
        <form-container :title="formTitle">
            <el-form ref="userForm" :model="userForm" v-loading="loading" status-icon :rules="rules" label-width="100px">
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input type="password" v-model="userForm.oldPassword" autocomplete="off" class="one-third-width"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="userForm.password" autocomplete="off" class="one-third-width"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="checkPassword">
                    <el-input type="password" v-model="userForm.checkPassword" autocomplete="off" class="one-third-width"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save">保存</el-button>
                </el-form-item>
            </el-form>
        </form-container>
    </page-container>
</template>

<script>
import md5 from 'js-md5';
export default {
    name: "ChangePassword",
    data()
    {
        let checkPassword = (rule, value, callback)=>
        {
            if(!value)
            {
                callback(new Error('请输入密码'));
            }
            else if(value.length < 6 || value.length > 16)
            {
                callback(new Error('请输入6-12位密码'));
            }
            else
            {
                callback();
            }
        };
        let validateCheckPassword = (rule, value, callback) => {
            if (value !== this.userForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            userForm: {
                oldPassword: '',
                password: '',
                checkPassword: '',
            },
            rules: {
                oldPassword: [
                    { required: true, message: '请输入原密码', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { validator: checkPassword, trigger: 'blur' }
                ],
                checkPassword: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validateCheckPassword, trigger: 'blur' }
                ]
            },
            loading: false,
            formTitle: "修改密码"
        };
    },
    mounted()
    {
        // console.log('user edit mounted.', this.$route.query);
    },
    methods: {
        save()
        {
            console.log(this.userForm);
            this.$refs.userForm.validate(valid =>
            {
                if(!valid) return;
                this.loading = true;
                let data = this.userForm;
                data.oldPassword = md5(this.userForm.oldPassword);
                data.password = md5(this.userForm.password);
                data.checkPassword = md5(this.userForm.checkPassword);
                return Fx.Http.post("/system/user/changePassword", data).
                then((resp)=>
                {
                    this.loading = false;
                    if(resp.isSuccess() && resp.getData("result") == 'OK')
                    {
                        this.showMessageSuccess('保存成功',()=>
                        {
                            this.dispatchRouteBack();
                        });
                    }
                    else
                    {
                        this.showMessageError(resp.getErrorMessage());
                    }
                });
            });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/system/pages/user/ChangePassword.vue